import { merge, forEach } from 'lodash';
import { createHttpActionsFor } from './client';

/* API resources/endpoints that are accessible to the web */

const API_RESOURCES = [
  {
    name: 'address-book',
  },
  {
    name: 'admin',
  },
  {
    name: 'plan',
  },
  {
    name: 'credit',
  },
  { name: 'contact' },
  {
    name: 'crm',
  },
  {
    name: 'credit-scheme',
  },
  {
    name: 'sender-name',
  },
  { name: 'sms-template' },
  { name: 'purchase' },
  { name: 'payment' },
  {
    name: 'vendor',
  },
  {
    name: 'reseller',
  },
];

/* http actions exposed by this client */
export const httpActions = {};

export * from './client';

forEach(API_RESOURCES, (resource) => {
  const resourceHttpActions = createHttpActionsFor(resource);
  merge(httpActions, resourceHttpActions);
});
